export const h = {		
	login:{		
			login:"ログイン",
			pleaseusername:"ユーザー名を入力してください",
			pleasepassword:"パスワードを入力してください",
			checkname:"正しいユーザー名を入力してください",
			checkpass:"パスワードは 3 文字未満にすることはできません",
		},	
	navbar:{	
		home:"表紙",
		mycenter:"パーソナルセンター",
		outlogin:"やめる",
		close:"閉鎖",
		editLanguage:"編集言語",
	},	
	vip:{	
		nickname:"ニックネーム",
		pleasenickname:"ニックネームを入力してください",
		username:"ユーザー名",
		pleaseusername:"ユーザー名を入力してください",
		arealogin:"ログインエリア",
		pleasearealogin:"ログインエリアを入力してください",
		nationality:"国籍",
		pleasenationality:"国籍を選択してください",
		depositstatus:"入金状況",
		pleasedepositstatus:"入金ステータスを選択してください",
		createtime:"作成時間",
		logintime:"ログイン時間",
		startime:"開始時間",
		endtime:"終了時間",
		no:"シリアルナンバー",
		shangji:"上司への直接推薦",
		keyongmoney:"利用可能残高",
		baozhengjing:"マージン",
		fudongyingkui:"変動損益",
		zicantotal:"総資産",
		yaoqingma:"招待コード",
		zongrujing:"総預金額",
		zongchujing:"引き出し総額",
		loginIp:"ログインIP",
		zuihoulogin:"最終ログイン時間",
		shoucirujingmoney:"初回入金額",
		shoucirujingtime:"初回入金時間",
		kaitongtime:"開始時間",
		keyong:"利用可能",
		daoshi:"家庭教師",
		dongjie:"氷結",
		chujingstate:"出金状況",
		xiajichujingstate:"下位レベルの引き出しステータス",
		caozuo:"操作する",
		chakan:"チェック",
		heji:"合計",
		moneytotal:"総合収支",
		paixu:"選別",
		daochu:"輸出",
		huiyuanguanli:"会員管理",
		yonghu:"ユーザー",
		search:"クエリ検索",
		reset:"リセット",
		delete:"消去",
		kickout:"追い出す",
		notlogin:"ログインしていない",
		editLanguage:"編集言語",
		yourujing:"デポジットあり",
		wurujing:"デポジットなし",
    juese: "役割",
    xiugaimima: "パスワード変更",
    jiumima: "旧パスワード",
    shurujiumima: "旧パスワードを入力してください",
    xinmima: "新パスワード",
    shuruxinmima: "新パスワードを入力してください",
    gerenzhongxing: "個人センター",
    yonghuxinxi: "ユーザー情報"
	},	
	info:{	
		home:"ホームページ",
		user:"ユーザーID",
		nickname:"ニックネーム",
		account:"アカウント",
		identity:"ID番号",
		phone:"電話番号",
		nationality:"国籍",
		Balance:"残高管理",
		real:"リアルアカウント",
		zhongmongy:"総合収支",
		keyongmoney:"利用可能残高",
		jiaoyidongjie:"トランザクションの凍結",
		shishilirun:"リアルタイム利益",
		shishikeyong:"リアルタイムで利用可能",
		xunizhanghu:"バーチャルアカウント",
		churujinguanli:"入出金管理",
		chakanzijinjilu:"ファンド履歴を見る",
		rujinjilu:"入金記録",
		rujinjine:"入金額",
		jiaoyibishu:"トランザクション数",
		chujinjilu:"出金記録",
		chujinjine:"出金額",
		jiaoyiguanli:"トランザクション管理",
		lishijilu:"歴史の記録",
		chakanlishi:"過去の取引情報を表示する",
		jiaoyishoushu:"取引ロット",
		jiaoyiyingkui:"売買損益",
		dangqianchicang:"現在位置",
		chakandangqianchicang:"現在位置情報を見る",
		dangqianguadan:"現在の未決注文",
		chakanguadanliebiao:"未決注文リストを表示する",
		guadanbishu:"未決注文の数",
		yongjinguanli:"コミッション管理",
		duanwei:"ランク",
		wu:"なし",
		zhishushangji:"直属の上司",
		shangjidaili:"優秀なエージェント",
		xiajituandui:"部下チーム",
		shurudailiname:"エージェント名を入力してください",
		chakan:"チェック",
		fanyongjie:"リベート額",
		fanyongbishu:"リベート数",
		chakanyongjinjilu:"リベート記録の表示",
		chakanyonghuinfo:"ユーザーの詳細を表示する",
		chakanwenjuan:"アンケートを見る",
		resetpassword:"パスワードを再設定する",
		sendmsg:"メッセージを送る",
		update:"改訂",
		unbound:"バインドされていません",
		weishiming:"実名認証なし",
		gendan:"文書管理",
		gensui:"フォローする",
		chakangendan:"注文記録の表示",
		dingdanhao:"注文番号",
		shoudongpay:"手動充電",
		chakanyongjingjilu:"コミッション履歴の表示",
		xiugaiyonghuxinxi:"ユーザー情報の変更",
		queding:"もちろん",
		quxiao:"キャンセル",
		email:"郵便",
		selguoji:"国籍を選択してください",
		sendusermsg:"ユーザーにメッセージを送信する",
		title:"タイトル",
		shurutitle:"メッセージのタイトルを入力してください",
		content:"コンテンツ",
		shurucontent:"メッセージ内容を入力してください",
		zhenshi:"現実",
		xuni:"バーチャル",
		fangxiang:"方向",
		zhanghu:"アカウント",
		add:"増加",
		less:"控除する",
		type:"タイプ",
		guanliyuanpay:"管理者リチャージ",
		pay:"補充する",
		money:"額",
		updategdmsg:"注文情報の変更",
		xinhaoyuan:"信号源",
		yes:"はい",
		no:"いいえ",
		updateyongjingmsg:"コミッション情報の変更",
		qingxuanzejuese:"アカウントの役割を選択してください",
		zuoduo:"長く続けてください",
		zuokong:"短い",
		gensuinicheng:"ニックネームをフォローする",
		kaicangjia:"始値",
		pingcangjia:"終値",
		shousu:"ロットサイズ",
		pingcangdate:"ポジション開始日",
		kaicangdate:"決算日",
		chakangensuiinfo:"フォローの詳細を表示",
		gensuiuserno:"ユーザー番号をフォローする",
		gensuiyonghuname:"ユーザーのニックネームをフォローする",
		gensuifangshji:"メソッドに従ってください",
		number:"量",
		danwei:"ユニット",
		zhengxiang:"フォワード",
		fanxaing:"逆行する",
		beishu:"複数",
		shousu:"ロットサイズ",
		gensuizhuangtai:"ステータスをフォローする",
		genjinzhong:"申し込みは以下の通り",
		gensuiok:"フォローすることに同意する",
		gensuino:"フォローを拒否されました",
		chexiao:"キャンセル",
		gensuidate:"フォロータイム",
		chakanlishijiaoyi:"過去の取引情報を表示する",
		chakanguadanlist:"未決注文リストを表示する",
		heyue:"契約",
		daili:"演技",
		huiyuanname:"メンバーの名前",
		xianjia:"価格制限",
		zhisun:"ストップロス",
		guadanjia:"未決注文価格",
		zhiyingzhisun:"テイクプロフィットとストップロス",
		zhiyingjia:"利食い価格",
		zhiyinghuichejia:"テイクプロフィットリトレースメント価格",
		zhisunjia:"ストップロス価格",
		zhisunhuichejia:"ストップロスリトレースメント価格",
		weiset:"設定されていません",
		zt:"州",
		chakanchicangmsg:"現在位置情報を見る",
		shouyiId:"受取人ID",
		xiajiid:"下位ユーザーID",
		xiajiuser:"部下のユーザー名",
		fanyongmonney:"リベート額",
		tuihuibaozhengjing:"デポジットの返却",
		shouxufei:"手数料",
		shouyi:"所得",
		lixi:"興味",
		zengmoney:"ボーナス",
		zhuijiabaozhengjing:"マージンコール",
		fanyong:"リベート",
		rujing:"デポジット",
		chujing:"資金を引き出す",
		chujingshibai:"出金審査が通らなかった場合の返金",
		guanliyuanless:"管理者控除",
		pingzhong:"バラエティ",
		shengqingzhong:"申請中",
		wancheng:"仕上げる",
		chongzhimima:"パスワードのリセットが成功しました",
		copy:"コピー",
		zhanghaomima:"アカウントパスワード",
		fenye:"記事/ページ",
    tixianmima:"キャッシュパスワード",
		gong:"一般",
		tiao:"ストリップ",
		ye:"ページ",
		goto:"に行く",
		outtitle:"ログアウトしました。キャンセルしてこのページに留まるか、再度ログインすることができます。",
		outok:"ログアウトしてもOK",
		chongxingdenglu:"再登録",
		cancel:"キャンセル",
		pingtai:"プラットホーム",
		nodata:"データなし",
    shangjiID: "上級ID",
    shangjiaccount: "上級アカウント",
    shangjiname: "上級ニックネーム",
    shangjinickname: "上級名前",
    zhongyingkui: "総損益",
    fuying: "浮動利益",
    yue: "残高",
    sheng: "昇順",
    jiang: "降順"
	},	
	history:{		
			guadan:"利益と損失",
			shijia:"保留中の注文",
			gendan:"市場価格",
			dangqianjia:"命令に従う",
			geyelixi:"現在の価格",
			weituodate:"一晩利息",
			pingcangfangshi:"コミッションタイム",
			dingdanyongjing:"開閉方法",
			shoudongpingcang:"注文手数料",
			qiangzhipingcang:"手動で閉じる",
			gendanpingcang:"強制清算",
			baocang:"清算",
			yuguqiangpingjia:"注文に従ってポジションを決済する",
			kaicangdiqu:"推定強制パリティ価格",
			ispingcang:"開口部エリア",
			tips:"強制清算についてよろしいですか？",
			pincangsucc:"ヒント",
			queding:"ポジションが正常にクローズされました",
			cancel:"もちろん",
		},	

	Langswitch: {	
	  "en":"英語",	
	  "id":"インドネシア語",	
	  "th":"タイ語",	
	  "vi":"ベトナム語",	
	  "zh":"中国語",	
	  "fa":"フランス語",	
	  "han":"韓国語",	
	  "tu":"トルコ語",	
	  "pu":"ポルトガル語",	
	  "xi":"スペイン語",	
	  "jp":"日本語",	
	  "ar":"アラビア語",	
	},	
}		



// WEBPACK FOOTER //
// ./src/i18n/langs/jp.js